import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
} from 'views/components';
import {translate} from 'views/module';

const ResetPasswordDialog = (props) => {
  const {open, onClose, onSubmit, isLoading} = props;
  const [password, setPassword] = React.useState('');

  const handlePasswordChange = (e) => {
    setPassword(e);
  };

  const handleSubmit = () => {
    if (password) {
      onSubmit(password);
      onClose();
    }
  };

  const handleClose = () => {
    setPassword('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        {translate('client.ClientDetail.Relationships.Authentication.Dialogs.ResetPasswordTitle')}
      </DialogTitle>
      <DialogContent>
        <Box sx={{mt: 1}}>
          <TextField
            label={translate('client.ClientDetail.Relationships.Authentication.Dialogs.NewPassword')}
            type="password"
            fullWidth
            value={password}
            onChange={handlePasswordChange}
            margin="normal"
            disabled={isLoading}
            autoFocus
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={isLoading}>
          {translate('client.ClientDetail.Relationships.Authentication.Cancel')}
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          disabled={isLoading || !password}
          startIcon={isLoading ? <CircularProgress size={20} /> : null}
        >
          {translate('client.ClientDetail.Relationships.Authentication.Submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ResetPasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

ResetPasswordDialog.defaultProps = {
  isLoading: false,
};

export default ResetPasswordDialog;
